<template>
  <center>
    <div class="card card-body agatrs-card-style">
      <Header pageTitle="ACSA Overdue Reports" class="card-container"></Header>
      <div class="row align-center">
        <div class="col-md-8">
          <h4>Select the report button to generate that report.<br /> 
          Once the report opens, double click on your organization’s overdue amount to see detailed information.</h4>
        </div>
      </div>
      <div class="row mt-5 ml-2 align-text">
        <div class="col-md-3">
          <base-button type="primary" class="btn-primary"
            @click="generateReport(`/api/acsareports/acsaoverdue`, 'ACSA_Overdue_Report.xlsx')">
            Detailed Overdue Report
          </base-button>
        </div>
        <div class="col-md-8 text-left">
          <p>The Detailed Overdue Report includes all active orders tagged as overdue and/ or delinquent by organization
            and subcomponent. The report includes basic transaction information (like requisition number and monetary
            value) as well as names of authorized requester, acceptor, receiver, and supplier.</p>
        </div>
      </div>
      <div class="row mt-5 align-text">
        <div class="col-md-3">
          <base-button type="primary" class="btn-primary"
            @click="generateReport(`/api/acsareports/serviceoverduesummary`, 'ACSA_Quarterly_Overdue_Report.xlsx')">
            Quarterly Overdue Report
          </base-button>
        </div>
        <div class="col-md-8 text-left">
          <p>The Quarterly Overdue Report can be used to validate overdue and delinquent transactions for the quarterly
            report. It includes all active orders for the current FY broken out by service and organization. The report
            includes basic transaction information (like requisition number and monetary value). This report format is
            used by OUSD to fulfill Quarterly and Annual Reporting requirements.</p>
        </div>
      </div>
      <div class="row mt-5 align-text">
        <div class="col-md-3">
          <base-button type="primary" class="btn-primary"
            @click="generateReport(`/api/acsareports/ninetydayoverdue`, '90_Day_Overdue.xlsx')">
            90 Day Overdue Forecast
          </base-button>
        </div>
        <div class="col-md-8 text-left ">
          <p>The 90 Day Overdue Forecast describes orders that will be tagged as overdue or delinquent in the next 90 days
            by order number. This report offers the same filters as the Quarterly Overdue Report. This report can support
            user understanding of upcoming order delinquency.</p>
        </div>
      </div>
    </div>

  </center>
</template>


<script>
import Header from "@/components/App/Header.vue";
import axios from "@/axios";
import swal from "sweetalert2";
import Util from "@/util/util";
import Utility from "@/mixins/utility/utility";
import LoadingAlertMixin from "@/mixins/docLoadingAlert";

export default {

  name: "OverdueReport",
  mixins: [LoadingAlertMixin],
  components: {
    Header,
  },
  methods: {
    async generateReport(url, title) {
      let ctx = this;

      this.excelLoadTime += 1;

      axios({
        url: url,
        method: "GET",
        responseType: "blob", // important
      })
      .then((response) => {
        Util.fileDownload(response.data, title);
        ctx.excelLoadTime = 0;
        ctx.closeLoadingAlert();
      })
      .catch((error) => {
        ctx.excelLoadTime = 0;
        ctx.closeLoadingAlert();
        swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Report Failed. Please try again later.',
          confirmButtonText: 'OK'
        });
      });

      await new Promise(r => setTimeout(r, 2000));

      if (this.excelLoadTime != 0) {
        this.showLoadingSweetAlert('Your Excel document is loading.<br><br>This message will disappear automatically in 10 seconds.');
      }

      while (this.excelLoadTime != 0) {
        await new Promise(r => setTimeout(r, 10000));
        if (this.excelLoadTime != 0) {
          this.updateLoadingMessage('Please hang tight. Your Excel document is <i>still loading</i>.<br><br><b>Note: <br>Depending on how many orders you export, it could take anywhere from a few seconds to over 5 minutes.');
        }
      }
    },
  }
}
</script>


<style>
.align-text{
    width: 87%;
    text-wrap: auto;
}
</style>